$(document).ready(function () {
    const expanded = (el) => {
        el.removeClass('mdi-chevron-down')
            .addClass('mdi-chevron-up')
            .addClass('text-black3')
            .removeClass('text-black1');
    };

    const collapsed = (el) => {
        el.removeClass('mdi-chevron-up')
            .addClass('mdi-chevron-down')
            .addClass('text-black1')
            .removeClass('text-black3');
    };

    const targets = $('.accordion-component > .card');

    // The first item in the accordion is always open by default.
    expanded(targets.first().find('> .card-header > .accordion-icon > i'));

    targets.on('show.bs.collapse', function () {
        expanded($(this).find('.accordion-icon > i'));
    });

    targets.on('hide.bs.collapse', function () {
        collapsed($(this).find('.accordion-icon > i'));
    });
});
